export default __webpack_public_path__ + "assets/sounds/2be042a2740f1caa68fac8a694314594.mp3";